import React, { useEffect, useState } from "react";
import backgroundImage from "../../../../assets/images/dw20/score-bg.png";
import { connect } from "react-redux";
import _ from "lodash";
const tempImage =
  "https://pbs.twimg.com/profile_images/3533319566/f4f7702092c31e3a6787d00d0fe26b71.jpeg";
let winner = "";
const HeadCard = (props) => {
  const {
    children,
    scoresTitle = "",
    isGameOver = false,
    game_over_text
  } = props;
  return (
    <div
      className="head-card"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div>
        {isGameOver && (
          <p className="isGameOver">
            {game_over_text ? game_over_text : "Game Over"}
          </p>
        )}
        <p className="scores-title">{scoresTitle}</p>
      </div>
      {children}
    </div>
  );
};
const CardView = (props) => {
  return (
    <>
      {props.text !== "" && props.cardText !== "" && (
        <>
          <div className="profile-image-view">
            <img src={winner.profile_image} />
          </div>
          <div className="head-card-CardView">
            <div className="view-card card-left">
              <span className="hash-tag-code">#DoneWith2020</span>
              <p>{props.text.replace(/\[BLANK]/g, "________")}</p>
            </div>
            <div className="view-card card-right">
              <span className="hash-tag-code">#DoneWith2020</span>
              <p>{props.cardText}</p>
            </div>
          </div>
        </>
      )}
    </>
  );
};
const ImageView = (props) => {
  let images = props.gifImage;
  return (
    <div className="head-card-ImageView">
      <div className="person-image-wrapper">
        <div className="person-image">
          <img src={winner.profile_image} />
        </div>
      </div>
      <div className="person-image-wrapper">
        <div className="person-image">
          <img src={images ? images : ""} />
        </div>
      </div>
    </div>
  );
};
const findWinner = (data) => {
  const { users, playerId } = data;
  if (users && users.length > 0) {
    users.map((item) => {
      if (item.player_id === playerId) {
        winner = item;
      }
    });
  }
};
const ScoreSection = (props) => {
  let roomData = _.get(props, "gameReducer.roomObj");
  let status = _.get(roomData, "game_state.status") || "";
  let gameData = _.get(props, "paramsReducer.gameObj.screens.dw");
  let game_over_text = _.get(gameData, "game_over_text");
  let game_over_gif = _.get(gameData, "game_over_gif");

  let scoresTitle = roomData.game_state.played_cards;
  let cardText = "";
  let text = roomData.game_state.prompt;
  let gameOver = roomData.game_state.player_hands;
  let score_to_win = roomData.game_state.game_parameters.score_to_win;
  const defaultTrack =
    _.get(props, "paramsReducer.gameObj.tabletop_default_sound") || "";

  useEffect(() => {
    if (status === "Result" || status === "Over") {
      playAudio(defaultTrack);
    }
  }, [status]);

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none";
    audio.autoplay = true;
    audio.onended = function () {
      audio.remove();
    };
    document.body.appendChild(audio);
  };

  return (
    <div className="dw20-ScoreSection">
      {roomData &&
        roomData.game_state.status === "Result" &&
        scoresTitle &&
        scoresTitle.length > 0 &&
        scoresTitle.map((item) => {
          if (item.winner) {
            cardText = item.card.text;
            let data = {
              users: roomData.users,
              playerId: item.player_id
            };
            findWinner(data);
          }
        })}
      {roomData && roomData.game_state.status === "Result" && (
        <HeadCard scoresTitle={winner.display_name + " Scores!"}>
          <CardView cardText={cardText} text={text} winner={winner} />
        </HeadCard>
      )}

      {roomData &&
        roomData.game_state.status === "Over" &&
        gameOver &&
        gameOver.length > 0 &&
        gameOver.map((item) => {
          if (item.score === score_to_win) {
            let data = {
              users: roomData.users,
              playerId: item.player_id
            };
            findWinner(data);
          }
        })}

      {roomData && roomData.game_state.status === "Over" && (
        <HeadCard
          isGameOver
          scoresTitle={winner.display_name + " Wins!"}
          game_over_text={game_over_text}
        >
          {roomData &&
            roomData.game_state.status === "Over" &&
            roomData.game_state.game_outputs && (
              <ImageView gifImage={game_over_gif} />
            )}
        </HeadCard>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScoreSection);
